import React from 'react';
import tw from 'twin.macro';
import { Link, useLocation } from 'react-router-dom';

export const NavLink = ({
  to,
  children,
  sidebarLink,
  animated = false,
  isFooter,
  ...restProps
}) => {
  const { pathname } = useLocation();
  return (
    <Link
      to={to}
      css={[
        tw`relative cursor-pointer`,
        !sidebarLink && tw`border-primary p-2 border-b-0 transition-all`,
        sidebarLink &&
          tw`block p-2 border-l-0 hover:text-default hover:pl-4 border-l-4 border-transparent transition-all`,
        pathname === to && sidebarLink && tw`pl-4 border-l-4 border-brand`,
      ]}
      {...restProps}
    >
      {children}
      {pathname === to && !sidebarLink && !animated && (
        <div
          css={[
            tw`w-full h-[3px] absolute -bottom-1 left-0 right-0 bg-brand`,
            isFooter && tw`-top-1`,
          ]}
        ></div>
      )}
    </Link>
  );
};
